import { render } from "./03_HouseholdInformationPage.vue?vue&type=template&id=774b8451&scoped=true"
import script from "./03_HouseholdInformationPage.vue?vue&type=script&lang=js"
export * from "./03_HouseholdInformationPage.vue?vue&type=script&lang=js"

import "./03_HouseholdInformationPage.vue?vue&type=style&index=0&id=774b8451&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774b8451"]])

export default __exports__